import _ from "lodash";

export type Status = "active" | "paused" | "canceled";

export const statuses: Status[] = ["active", "paused", "canceled"];

export const selectStatuses = statuses.map((status) => {
  return { value: status, label: status.replaceAll("_", " ").toUpperCase() };
});

export const colorsByStatus: Record<Status, string> = {
  active: "green",
  canceled: "yellow",
  paused: "orange",
};
